import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Switch } from '@material-ui/core'
import { editCollectionRegister, handleChangeController } from '../../../redux/actions/form'
import { useCollection } from '../../../utility/hooks/useCollection'
import { removeError } from '../../../redux/actions/validator'

export const Toggle = (props) => {

    const { name,
        label,
        className = '',
        containerClassname = 'mt-1',
        color = "primary",
        collection = [] } = props

    const dispatch = useDispatch()
    const { form, validator } = useSelector(state => state)
    const nodeForm = useCollection().getCollectionNode(form, collection)
    const [chk, setChk] = useState(nodeForm[name])
    const lab = label instanceof Array ? label[+chk || 0] : label

    const handleChange = () => {
        if (validator.errors && validator.errors[name]) delete validator.errors[name]
        if (collection.length === 0) dispatch(handleChangeController(name, !chk))
        else dispatch(editCollectionRegister(collection, { name, value: !chk }, true))
        dispatch(removeError(validator.errors))
        dispatch(handleChangeController('edited', true))
        setChk(!chk)
    }

    useEffect(() => { setChk(nodeForm[name]) }, [nodeForm])

    return (
        <div className={containerClassname} >
            {label && <label className="control-label d-flex justify-content-between">{lab}</label>}
            <Switch
                key={name}
                className={`${className}`}
                id={name}
                name={name}
                color={color}
                checked={chk}
                onChange={handleChange}
            />
        </div>
    )
}